import React from 'react';
import PropTypes from 'prop-types';
import createNumberMask from 'text-mask-addons/dist/createNumberMask';
import { eq, omit } from 'lodash';
import Field from '../Field';
import Input from '../Input';

export default class NumericField extends React.Component {
  static defaultProps = {
    maskProps: {
      prefix: '',
      includeThousandsSeparator: false,
    },
    guide: false,
  };

  static propTypes = {
    guide: PropTypes.bool,
    maskProps: PropTypes.shape({
      prefix: PropTypes.string,
      suffix: PropTypes.string,
      includeThousandsSeparator: PropTypes.bool,
      thousandsSeparatorSymbol: PropTypes.string,
      allowDecimal: PropTypes.bool,
      decimalSymbol: PropTypes.string,
      decimalLimit: PropTypes.number,
      integerLimit: PropTypes.number,
      requireDecimal: PropTypes.bool,
      allowNegative: PropTypes.bool,
      allowLeadingZeroes: PropTypes.bool,
    }),
  };

  constructor(props) {
    super(props);

    this.state = {
      mask: createNumberMask(props.maskProps),
    };
  }

  UNSAFE_componentWillReceiveProps({ maskProps }) {
    if (eq(maskProps, this.props.maskProps)) {
      return;
    }

    this.setState({
      mask: createNumberMask(maskProps),
    });
  }

  render() {
    const fieldProps = omit(this.props, ['maskProps']);

    return (
      <Field {...fieldProps}>
        <Input mask={this.state.mask} />
      </Field>
    );
  }
}
